import React from "react";
import "./RoboticsLife.css";

function RoboticsLife() {
  return (
    <>
      <section>
        <div className="bg-color">
          <div className="bg">
            <div className="txt align-center">
              <div>
                <h1>William James Sidis</h1>
                <p className="tl">
                  Powstanie człowieka idealnego, który uosabiałby wszystkie
                  najlepsze cechy gatunku, od zarania było dążeniem wielu
                  myślicieli, szkół filozoficznych, ideologii czy zwykłych
                  ludzi, którzy pragnęli zmaksymalizować swój potencjał.
                  Człowieka o największej inteligencji próbował stworzyć również
                  Borys Sidis, który przeprowadził eksperyment na własnym
                  dziecku. William James Sidis miał mieć IQ dochodzące do 300,
                  lecz jego życie zakończyło się tragicznie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RoboticsLife;
